import headers from './components/headers.vue'
import footers from './components/footers.vue'
import hero from './components/hero.vue'
import breadcrumb from './components/breadcrumb.vue'
import swiper from './components/swiper.vue'
import carousel from './components/carousel.vue'
import badge from './components/badge.vue'
import { createApp } from 'vue'

export default function partials(){
  return new Promise((resolve) => {
    const app = createApp({
      components: {
        headers: headers,
        footers: footers,
        hero: hero,
        breadcrumb: breadcrumb,
        swiper: swiper,
        carousel: carousel,
        badge: badge,
      }
    });
    
    // Vue.jsを#appにマウント
    app.mount('#app');
    resolve();
  });
}
